<div class="container">
  <div class="grid-row">
    <div class="xs-12">
      <div class="page-title">
        <dgx-components-icon
          [family]="'light'"
          [name]="'circle-check'"
        ></dgx-components-icon>
        <h3 class="make-type">
          {{ selected?.make }} {{ selected?.appliance_category }}
        </h3>
        <p class="model-number">{{ selected?.model }}</p>
      </div>
    </div>
  </div>
  <div class="grid-row">
    <div class="md-3"></div>
    <div class="xs-12 md-6">
      <div class="card">
        <h4 class="card-title">Order details</h4>
        <p class="typog-body mb-2">
          Thanks for ordering your brand-new model. We’ll send you a
          confirmation email shortly.
        </p>
        <p class="typog-body mb-2">
          You can now rest assured knowing that your replacement is on its way.
        </p>
        <a
          class="typog-body link mb-2"
          href="https://www.domesticandgeneral.com/content/help-advice-section/faq/replacements"
          target="_blank"
        >
          Find out more about deliveries in our FAQs.
        </a>

        <hr />
        <div class="order-details">
          <div>
            <p class="typog-body-bold">
              {{ selected?.make }} {{ selected?.appliance_category }}
              <span class="typog-body">{{ selected?.model }}</span>
            </p>
          </div>
        </div>

        <div class="product-details">
          <div class="color-energy">
            <ng-container
              *ngFor="let feature of selected?.key_features | keyFeatures"
            >
              <p *ngIf="feature.value" class="mb-1">{{ feature.name }}:</p>
            </ng-container>
          </div>
          <div class="hint">
            <ng-container
              *ngFor="let feature of selected?.key_features | keyFeatures"
            >
              <p *ngIf="feature.value" class="mb-1">{{ feature.value }}</p>
            </ng-container>
          </div>
        </div>

        <hr />

        <div class="replacement-cost">
          <p class="typog-body">
            <dgx-components-icon [family]="'light'" [name]="'box-check'">
            </dgx-components-icon>
            <span class="ml-2"> Replacement cost </span>
          </p>
          <p class="typog-body-bold">
            <span *ngIf="upfront?.upgradeFee">
              {{ upfront?.upgradeFee | currency : 'GBP' }}
            </span>
            <span *ngIf="!upfront?.upgradeFee" class="free">
              £0.00 to pay
            </span>
          </p>
        </div>

        <hr />

        <div class="installation">
          <p class="typog-body">
            <dgx-components-icon [family]="'light'" [name]="'person-dolly'">
            </dgx-components-icon>
            <span class="ml-2"> Installation fee </span>
          </p>
          <p
            class="typog-body-bold"
            [class.free]="
              !upfront?.installation?.price_gross &&
              upfront?.isInstallationAvailable &&
              upfront?.isInstallationSelected
            "
          >
            <ng-container
              *ngIf="upfront?.isInstallationAvailable; else NotAvailable"
            >
              <ng-container
                *ngIf="upfront.isInstallationSelected; else NotChosen"
              >
                {{
                  upfront?.installation?.price_gross
                    ? (upfront?.installation?.price_gross | currency : 'GBP')
                    : '£0.00 to pay'
                }}
              </ng-container>

              <ng-template #NotChosen>
                <strong>Not chosen</strong>
              </ng-template>
            </ng-container>

            <ng-template #NotAvailable>
              <strong>Not available</strong>
            </ng-template>
          </p>
        </div>

        <hr />

        <div class="recycling">
          <p class="typog-body">
            <dgx-components-icon [family]="'light'" [name]="'recycle'">
            </dgx-components-icon>
            <span class="ml-2"> Recycling fee </span>
          </p>
          <p
            class="typog-body-bold"
            [class.free]="
              !upfront?.disposal?.price_gross &&
              upfront?.isDisposalSelected &&
              upfront?.isDeliveryAvailable
            "
          >
            <ng-container *ngIf="upfront?.isDisposalSelected">
              <ng-container *ngIf="upfront?.disposal as disposal">
                {{
                  disposal?.price_gross
                    ? (disposal.price_gross | currency : 'GBP')
                    : '£0.00 to pay'
                }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!upfront?.isDisposalAvailable"
              ><strong>Not available</strong>
            </ng-container>
            <ng-container
              *ngIf="
                upfront?.isDisposalAvailable && !upfront?.isDisposalSelected
              "
            >
              <strong>Not chosen</strong>
            </ng-container>
          </p>
        </div>

        <hr />

        <div class="total">
          <p class="mr-2">Total</p>
          <p>
            {{
              upfront?.replacementCost
                ? (upfront?.replacementCost | currency : 'GBP')
                : '£0.00'
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="md-3"></div>
  </div>
</div>
